/**
 * Crasman multiselect component.
 * Documentation: https://git.crasmanhosting.fi/npm/multiselect/
 *
 * Settings can also be defined as data-attributes on each select element.
 * Related styles: _multiselect.css
 */

import Multiselect from '@crasman/multiselect';

const defaultSettings = {
  listElement: {
    size: 6
  },
  buttonElement: {
    showPlaceholder: true
  }
};

const multiselect = {
  init() {
    document.querySelectorAll('#main select').forEach(select => {
      if (select instanceof HTMLSelectElement) {
        const selectSettings = select.dataset;
        new Multiselect(select, {...defaultSettings, ...selectSettings});
      }
    });
  }
};

export default multiselect;
